import type {Meta, MetaTourOperatorSpecial} from '@/redux/v1/models';

import {unionBy, uniqBy} from 'lodash';

import {
  PROMOTION_CATEGORY_FLEX,
  PROMOTION_CATEGORY_SAFETY,
  PROMOTION_CATEGORY_SPECIAL,
} from '@/redux/v1/models';

// @TODO maybe this can be replaced by some "deepmerge" package eventually?
export const mergeMeta = (metaA?: null | Meta, metaB?: null | Meta): Meta => {
  return {
    ...metaA,
    tourOperatorSpecials: [
      PROMOTION_CATEGORY_SPECIAL,
      PROMOTION_CATEGORY_FLEX,
      PROMOTION_CATEGORY_SAFETY,
    ].reduce<Record<string, MetaTourOperatorSpecial>>((result, key) => {
      const categoryA = metaA?.tourOperatorSpecials?.[key];
      const categoryB = metaB?.tourOperatorSpecials?.[key];

      if (categoryA && !categoryB) {
        result[key] = categoryA;
      }
      if (!categoryA && categoryB) {
        result[key] = categoryB;
      }
      if (categoryA && categoryB) {
        const {variations: variationsA, ...restA} = categoryA;
        const {variations: variationsB, ...restB} = categoryB;

        result[key] = {
          ...restA,
          ...restB,
          variations: uniqBy(
            // @ts-expect-error ...
            [...variationsA, ...variationsB].filter(Boolean),
            'type'
          ),
        };
      }

      return result;
    }, {}),
    roomAttributes: unionBy(
      metaA?.roomAttributes ?? [],
      metaB?.roomAttributes ?? [],
      (roomAttribute) => roomAttribute.type
    ),
  };
};
